import React, { forwardRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
const siteKey = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_V2_CLIENT_TOKEN

type RecaptchaV2ReactProps = {
  onChange?: (value: string | null) => void
}

/**
 * Reusable Google reCAPTCHA v2 component.
 * @param {recaptchaRef} - Ref to the ReCAPTCHA component.
 *
 *  How to Use:
 *
 * 1. Import and create a ref:
 *    import ReCAPTCHA from 'react-google-recaptcha'
 *    const recaptchaRef = useRef<ReCAPTCHA | null>(null)
 *
 *
 * 2. Add component inside your form:
 *    <RecaptchaV2React ref={recaptchaRef} />
 *
 * 3. On form submit:
 *    const token = recaptchaRef.current?.getValue()
 *    if (!token) {
 *      toast.warning(t('Please complete the reCAPTCHA'))
 *      return
 *    }
 *
 *    const isValidToken = await verifyRecaptcha(token)
 *    if (!isValidToken?.valid) {
 *      toast.warning(t('Invalid reCAPTCHA token'))
 *      return
 *    }
 *
 *    // Optional: reset reCAPTCHA after use
 *    recaptchaRef.current?.reset()
 *
 *   Make sure your .env has:
 *    NEXT_PUBLIC_GOOGLE_RECAPTCHA_V2_CLIENT_TOKEN=your-site-key
 */

const RecaptchaV2React = forwardRef<ReCAPTCHA, RecaptchaV2ReactProps>(
  ({ onChange }, ref) => {
    if (!siteKey) {
      console.error('Google reCAPTCHA site key is not defined')
      return null
    }

    return <ReCAPTCHA sitekey={siteKey} onChange={onChange} ref={ref} />
  }
)

RecaptchaV2React.displayName = 'RecaptchaV2React'
export default RecaptchaV2React
